(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nx-bundle-compact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-product-complement')) {
    customElements.define('nx-product-complement', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.product = JSON.parse(this.querySelector('[data-nxc-product]').textContent);
        try { this.life = JSON.parse(this.querySelector('[data-nxc-life]')?.textContent || '{}'); } catch (e) { this.life = {}; }
        this.labels = JSON.parse(this.querySelector('[data-nxc-labels]').textContent);
        this.selects = [...this.querySelectorAll('[data-nxc-option]')];
        this.button = this.querySelector('.nx-complement__add');
        this.status = this.querySelector('.nx-complement__status');
        this.quantity = Number(this.dataset.quantity) || 1;
        this.colors = {'blanc':'#f6f4ef','blanc casse':'#f2ede2','ivoire':'#efe9dc','creme':'#efe6d6','champagne':'#dcc9a8','khaki':'#b9a88e','kaki':'#b0a894','beige':'#d9c9b2','beige sable':'#d8c8ae','sable':'#d5c4a5','taupe':'#a9998a','milk tea':'#d3bfa3','caramel':'#a96f3d','coffee':'#6b5138','cafe fonce':'#5d4a3a','cafe':'#a88a7a','marron':'#7a5c42','rose':'#e5b6ad','rose clair':'#e8c6c3','rose poudre':'#e5b6ad','terracotta':'#c4674a','orange':'#e08b4e','abricot':'#f0c9a8','jaune':'#e2c46f','rouge':'#a63d33','vert sauge':'#a9b5a2','vert':'#9fae9b','vert feuille':'#7f9377','vert eau':'#b8cec5','vert d eau':'#b8cec5','vert canard':'#4e7d78','bleu':'#8298b0','bleu gris':'#93a3b5','bleu fonce':'#34455e','bleu nuit':'#1e2a44','bleu ciel':'#cfdde8','bleu glacier':'#bcd2da','gris':'#b9b9b7','gris clair':'#c9c9c7','gris argent':'#c3c6c8','gris argente':'#c3c6c8','gris fume':'#8e8e8c','gris fonce':'#6d6d6b','gris perle':'#c6c6c4','gris ardoise':'#4a4747','gris brume':'#d3d5d4','amande':'#dce3cf','mauve':'#b5a8c9','noir':'#2b2b2b','naturel':'#d8c9b0','lin naturel':'#d8c9b0'};
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style: 'currency', currency: this.dataset.currency || 'EUR'});
        this.form = this.closest('form');
        this.abort = new AbortController();
        const colorSelect = this.selects.find(s => ['couleur','color','colour'].includes(this.norm(s.dataset.nxcName)));
        if (colorSelect) {
          const index = Number(colorSelect.dataset.nxcOption);
          const neutral = ['blanc','ivoire','naturel','beige sable','taupe'].map(name => [...colorSelect.options].find(o => this.norm(o.value) === name && this.product.variants.some(v => v.available && v.options[index] === o.value))).find(Boolean);
          if (neutral) colorSelect.value = neutral.value;
        }
        this.selects.forEach(select => select.addEventListener('change', () => this.update(), {signal:this.abort.signal}));
        this.button.addEventListener('click', () => this.add(), {signal:this.abort.signal});
        if (this.form) this.form.addEventListener('change', event => {
          if (event.target.closest('nx-product-complement')) return;
          if (event.target.matches('[data-option]')) this.sync(event.target);
        }, {signal:this.abort.signal});
        this.sync();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.initialized = false;
      }
      norm(value) { return String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase(); }
      handle(value) { return this.norm(value).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
      size(value) { return this.norm(value).replace(/\s|cm/g, '').replace('×','x'); }
      sync(changed) {
        const inputs = changed ? [changed] : [...(this.form?.querySelectorAll('[data-option]:checked, select[data-option]') || [])];
        inputs.forEach(input => {
          const optionName = this.norm(input.dataset.option);
          const color = ['couleur','color','colour'].includes(optionName);
          const size = this.dataset.syncSize === 'true' && (optionName.includes('taille') || optionName === 'titre' || optionName === 'size');
          if (!color && !size) return;
          const select = this.selects.find(s => color ? ['couleur','color','colour'].includes(this.norm(s.dataset.nxcName)) : !['couleur','color','colour'].includes(this.norm(s.dataset.nxcName)));
          if (!select) return;
          const normalize = value => size ? this.size(value) : this.norm(value);
          const target = [...select.options].find(o => normalize(o.value) === normalize(input.value))
            || (size ? [...select.options].find(o => this.size(o.value).replace('66x66','65x65') === this.size(input.value).replace('66x66','65x65')) : null);
          if (!target) return;
          const index = Number(select.dataset.nxcOption);
          if (!this.product.variants.some(v => v.available && v.options[index] === target.value)) return;
          select.value = target.value;
        });
        this.update();
      }
      update() {
        const values = this.selects.map(select => select.value);
        this.variant = this.product.variants.find(v => this.selects.every((s,i) => v.options[Number(s.dataset.nxcOption)] === values[i]));
        const variant = this.variant;
        this.button.disabled = this.busy || !variant?.available;
        this.button.textContent = !variant ? this.labels.unavailable : variant.available ? this.labels.add : this.labels.soldOut;
        this.button.removeAttribute('data-added');
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
        this.selects.forEach(select => [...select.options].forEach(option => {
          const index = Number(select.dataset.nxcOption);
          option.disabled = !this.product.variants.some(v => v.available && v.options[index] === option.value && this.selects.every(other => Number(other.dataset.nxcOption) >= index || v.options[Number(other.dataset.nxcOption)] === other.value));
        }));
        const colorSelect = this.selects.find(select => ['couleur','color','colour'].includes(this.norm(select.dataset.nxcName)));
        const colorDot = this.querySelector('[data-nxc-color-dot]');
        if (colorSelect && colorDot) {
          colorDot.style.background = this.colors[this.norm(colorSelect.value).replace(/[’'\-]/g,' ').replace(/\s+/g,' ')] || '#f1eee7';
          colorDot.setAttribute('title', colorSelect.value);
        }
        if (!variant) return;
        this.querySelector('.nx-complement__price').textContent = '+ ' + this.format.format(variant.price * this.quantity / 100);
        const colorIndex = this.product.options.findIndex(o => ['couleur','color','colour'].includes(this.norm(o.name || o)));
        let lifeSrc = null;
        if (this.life) lifeSrc = colorIndex >= 0 ? this.life[this.handle(variant.options[colorIndex])] : this.life._default;
        let image = variant.featured_image;
        if (!image && colorIndex >= 0) image = this.product.variants.find(v => v.options[colorIndex] === variant.options[colorIndex] && v.featured_image)?.featured_image;
        if (!image && colorIndex < 0) image = this.product.featured_image;
        const img = this.querySelector('.nx-complement__image');
        const source = typeof image === 'string' ? image : image?.src;
        if (img && lifeSrc) {
          img.removeAttribute('srcset');
          img.src = lifeSrc;
          img.alt = this.product.title + ' — ' + variant.title;
          img.hidden = false;
        } else if (img && source) {
          const url = new URL(source, location.origin);
          url.searchParams.set('width', '240');
          img.removeAttribute('srcset');
          img.src = url.href;
          img.alt = this.product.title + ' — ' + variant.title;
          img.hidden = false;
        } else if (img) img.hidden = true;
        const root = (this.dataset.root || window.Shopify?.routes?.root || '/').replace(/\/$/, '');
        this.querySelectorAll('a').forEach(a => {
          const url = new URL(this.product.url || '/products/' + this.product.handle, location.origin);
          const productPath = url.pathname.indexOf('/products/');
          if (productPath >= 0) url.pathname = root + url.pathname.slice(productPath);
          url.searchParams.set('variant', variant.id);
          a.href = url.pathname + url.search;
        });
      }
      async add() {
        if (this.busy || !this.variant?.available) return;
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.labels.adding;
        this.setAttribute('aria-busy','true');
        this.selects.forEach(select => select.disabled = true);
        try {
          const core = window.themeCore;
          if (core?.CartApi) {
            await core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART, {id:this.variant.id,quantity:this.quantity});
          } else {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
              body: JSON.stringify({items:[{id:this.variant.id,quantity:this.quantity}]})
            });
            const data = await response.json();
            if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : this.labels.error);
          }
          this.button.textContent = this.labels.added;
          this.button.setAttribute('data-added','');
          this.status.textContent = this.labels.success;
          if (core?.CartApi) core.CartApi.makeRequest(core.CartApi.actions.GET_CART).catch(() => {});
          else window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        } catch (error) {
          this.status.textContent = error.description || error.message || this.labels.error;
          this.status.setAttribute('data-error','');
          this.button.textContent = this.labels.add;
          this.button.disabled = false;
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.selects.forEach(select => select.disabled = false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-cart-complement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-cart-complement')) {
    customElements.define('nx-cart-complement', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.product = JSON.parse(this.querySelector('[data-nx-cart-product]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-nx-cart-labels]').textContent);
        this.selects = [...this.querySelectorAll('[data-nx-cart-option]')];
        this.button = this.querySelector('.nx-cart-complement__add');
        this.status = this.querySelector('.nx-cart-complement__status');
        this.price = this.querySelector('.nx-cart-complement__price');
        this.basePrice = this.price.textContent;
        this.format = new Intl.NumberFormat(this.dataset.locale || 'fr', {style:'currency',currency:this.dataset.currency || 'EUR'});
        this.abort = new AbortController();
        this.selects.forEach(select => select.addEventListener('change', () => this.update(), {signal:this.abort.signal}));
        this.button.addEventListener('click', () => this.add(), {signal:this.abort.signal});
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.initialized = false; }
      update() {
        const complete = this.selects.every(select => select.value !== '');
        this.variant = complete ? this.product.variants.find(v => this.selects.every(s => v.options[Number(s.dataset.nxCartOption)] === s.value)) : null;
        this.selects.forEach(select => [...select.options].forEach(option => {
          if (!option.value) return;
          const index = Number(select.dataset.nxCartOption);
          option.disabled = !this.product.variants.some(v => v.available && v.options[index] === option.value && this.selects.every(other => Number(other.dataset.nxCartOption) >= index || !other.value || v.options[Number(other.dataset.nxCartOption)] === other.value));
        }));
        this.button.disabled = this.busy || !this.variant?.available;
        this.button.textContent = !complete ? this.labels.choose : this.variant?.available ? this.labels.add : this.labels.unavailable;
        this.price.textContent = this.variant ? this.format.format(this.variant.price / 100) : this.basePrice;
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
        const img = this.querySelector('img');
        if (img && this.dataset.life) {
          img.removeAttribute('srcset'); img.src = this.dataset.life;
          img.alt = this.product.title + (this.variant ? ' — ' + this.variant.title : '');
        } else {
          const image = this.variant?.featured_image || this.product.featured_image;
          const source = typeof image === 'string' ? image : image?.src;
          if (img && source) {
            const url = new URL(source, location.origin); url.searchParams.set('width','160');
            img.removeAttribute('srcset'); img.src = url.href;
            img.alt = this.product.title + (this.variant ? ' — ' + this.variant.title : '');
          }
        }
        const link = this.querySelector('.nx-cart-complement__link');
        const url = new URL(this.product.url || '/products/' + this.product.handle, location.origin);
        if (this.variant) url.searchParams.set('variant',this.variant.id);
        link.href = url.pathname + url.search;
      }
      async add() {
        if (this.busy || !this.variant?.available) return;
        this.busy = true; this.button.disabled = true;
        this.button.textContent = this.labels.adding;
        this.status.textContent = ''; this.status.removeAttribute('data-error');
        this.setAttribute('aria-busy','true');
        this.selects.forEach(select => select.disabled = true);
        try {
          const core = window.themeCore;
          if (core?.CartApi) {
            await core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART,{id:this.variant.id,quantity:1});
            core.CartApi.makeRequest(core.CartApi.actions.GET_CART).catch(() => {});
          } else {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:1}]})
            });
            const result = await response.json();
            if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : this.labels.error);
            location.assign((window.Shopify?.routes?.root || '/') + 'cart');
          }
          this.button.textContent = this.labels.added;
          this.status.textContent = this.labels.success;
        } catch (error) {
          this.busy = false; this.button.disabled = false;
          this.button.textContent = this.labels.add;
          this.status.textContent = typeof error.description === 'string' ? error.description : error.message || this.labels.error;
          this.status.setAttribute('data-error','');
          this.selects.forEach(select => select.disabled = false);
        } finally { this.removeAttribute('aria-busy'); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-cart-popup-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-cart-popup-guard')) {
    customElements.define('nx-cart-popup-guard', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.scheduled = false;
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
        this.schedule();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
      schedule() {
        if (this.scheduled) return;
        this.scheduled = true;
        requestAnimationFrame(() => { this.scheduled = false; this.protectCheckout(); });
      }
      protectCheckout() {
        const cart = document.querySelector('#CartDrawer');
        if (!cart?.classList.contains('is-active')) return;
        document.querySelectorAll('[role="dialog"] [data-testid="POPUP"]').forEach(popup => {
          const dialog = popup.closest('[role="dialog"]');
          if (!dialog || dialog.dataset.nxCartDismissed) return;
          dialog.dataset.nxCartDismissed = 'true';
          const close = [...dialog.querySelectorAll('button')].find(button => {
            const label = [button.getAttribute('aria-label'), button.getAttribute('title'), button.textContent].filter(Boolean).join(' ').toLowerCase();
            return label.includes('close') || label.includes('fermer') || label.trim() === '×';
          });
          if (close) close.click();
          else {
            dialog.hidden = true;
            dialog.style.setProperty('display','none','important');
            document.body.classList.remove('klaviyo-prevent-body-scrolling');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-parure-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-parure-configurator')) {
  customElements.define('nx-parure-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      if (!this.form) return;
      this.abort = new AbortController();
      this.sheet = this.querySelector('[data-nxp-sheet]');
      this.cases = this.querySelector('[data-nxp-cases]');
      this.status = this.querySelector('[data-nxp-status]');
      this.variants = JSON.parse(this.querySelector('[data-nxp-all-variants]').textContent);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency',currency:this.dataset.currency || 'EUR'});
      this.addEventListener('change', event => this.prepare(event), {capture:true,signal:this.abort.signal});
      this.form.addEventListener('submit', event => {
        if (!this.busy) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.status.textContent = this.dataset.loading;
      }, {capture:true,signal:this.abort.signal});
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.querySelector('.js-product-options'), {childList:true});
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      clearTimeout(this.timeout);
      this.ready = false;
    }
    markSelected(select) {
      [...select.options].forEach(option => {
        if (option.selected) option.setAttribute('selected', 'selected');
        else option.removeAttribute('selected');
      });
    }
    composition(variant) { return String(variant?.option3 || variant?.options?.[2] || ''); }
    options(variant) { return variant.options || [variant.option1, variant.option2, variant.option3]; }
    isFour(variant) { return this.composition(variant).startsWith('Drap-housse '); }
    chooseVariant(candidates, focusId) {
      const current = this.options(this.variant);
      const sameSize = variant => this.options(variant)[0] === current[0] && this.options(variant)[1] === current[1];
      const sameColor = variant => this.options(variant)[0] === current[0];
      const next = candidates.find(sameSize) || candidates.find(sameColor) || candidates[0];
      if (!next) return;
      const target = this.options(next);
      this.querySelectorAll('input[data-option]').forEach(radio => radio.checked = radio.value === target[0]);
      const duvet = this.querySelector('[data-nxp-duvet]');
      const native = this.querySelector('[data-nxp-composition]');
      duvet.value = target[1];
      native.value = target[2];
      this.markSelected(duvet);
      this.markSelected(native);
      this.pendingFocusId = focusId;
      native.dispatchEvent(new Event('change', {bubbles:true}));
    }
    switchOffer(input) {
      const four = input.value === '4';
      let candidates = this.variants.filter(variant => this.isFour(variant) === four);
      const configured = candidates.filter(variant => this.composition(variant) !== 'Parure 3 pièces');
      if (configured.length) candidates = configured;
      this.chooseVariant(candidates, input.id);
    }
    prepare(event) {
      if (event.target.matches('[data-nxp-offer]')) { this.switchOffer(event.target); return; }
      if (!event.target.matches('[data-option], [data-nxp-sheet], [data-nxp-cases]')) return;
      if (event.target === this.sheet || event.target === this.cases) {
        const value = this.isFour(this.variant) ? 'Drap-housse ' + this.sheet.value + ' | Taies ' + this.cases.value : this.cases.value === 'original' ? 'Parure 3 pièces' : 'Taies ' + this.cases.value;
        const candidates = this.variants.filter(variant => this.composition(variant) === value);
        if (!candidates.length) {
          event.stopImmediatePropagation();
          this.status.textContent = this.dataset.error;
          this.status.setAttribute('data-error','');
          return;
        }
        this.chooseVariant(candidates, event.target.id);
        return;
      }
      this.busy = true;
      this.setAttribute('aria-busy','true');
      this.status.removeAttribute('data-error');
      this.status.textContent = this.dataset.loading;
      this.form.querySelectorAll('[type="submit"]').forEach(button => button.disabled = true);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (!this.busy) return;
        this.status.textContent = this.dataset.error;
        this.status.setAttribute('data-error','');
      }, 12000);
    }
    sync() {
      const selected = this.querySelector('[data-selected-variant]');
      if (!selected) return;
      let variant;
      try { variant = JSON.parse(selected.textContent); } catch { return; }
      if (!variant || !this.variants.some(item => item.id === variant.id)) return;
      this.variant = variant;
      const four = this.isFour(variant);
      const legacy = this.composition(variant) === 'Parure 3 pièces';
      this.sheet = this.querySelector('[data-nxp-sheet]');
      this.cases = this.querySelector('[data-nxp-cases]');
      const display = value => value.replaceAll(' x ',' × ') + ' cm';
      const sheetProperty = this.querySelector('[data-nxp-sheet-property]');
      const casesProperty = this.querySelector('[data-nxp-cases-property]');
      if (sheetProperty) sheetProperty.disabled = !four;
      casesProperty.disabled = legacy;
      this.querySelector('[data-nxp-offer-property]').value = four ? this.dataset.four : this.dataset.three;
      if (four) {
        const composition = this.composition(variant).split(' | Taies ');
        this.sheet.value = composition[0].replace('Drap-housse ','');
        this.cases.value = composition[1];
        this.markSelected(this.sheet);
        this.markSelected(this.cases);
        sheetProperty.value = display(this.sheet.value);
      } else {
        this.cases.value = legacy ? 'original' : this.composition(variant).replace('Taies ', '');
        this.markSelected(this.cases);
      }
      casesProperty.value = legacy ? '' : display(this.cases.value);
      const duvet = String(variant.option2 || variant.options[1]);
      this.querySelector('[data-nxp-duvet-property]').value = display(duvet);
      this.form.querySelector('[name="id"]').value = variant.id;
      this.form.querySelectorAll('[data-product-price]').forEach(price => price.textContent = this.money.format(variant.price / 100));
      this.form.querySelectorAll('[type="submit"]').forEach(button => {
        button.disabled = !variant.available;
        button.textContent = variant.available ? this.dataset.add + ' — ' + this.money.format(variant.price / 100) : this.dataset.soldOut;
      });
      if (this.pendingFocusId) {
        this.querySelector('[id="' + this.pendingFocusId + '"]')?.focus({preventScroll:true});
        this.pendingFocusId = null;
      }
      this.busy = false;
      this.removeAttribute('aria-busy');
      this.status.textContent = '';
      this.status.removeAttribute('data-error');
      clearTimeout(this.timeout);
    }
  });
  const syncParures = () => document.querySelectorAll('nx-parure-configurator').forEach(configurator => {
    if (configurator.ready && !configurator.busy) configurator.sync();
  });
  const listenForProducts = () => {
    window.themeCore?.EventBus?.listen('product:loaded', syncParures);
    syncParures();
  };
  if (window.themeCore?.EventBus) listenForProducts();
  else document.addEventListener('theme:all:loaded', listenForProducts, {once:true});
  window.addEventListener('load', syncParures, {once:true});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-size-guide-drawer"] && !Shopify.designMode) return;
  try {
    if (!window.nxSizeGuideDrawerReady) {
  window.nxSizeGuideDrawerReady = true;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-nx-size-guide-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog?.matches('[data-nx-size-guide-dialog]')) return;
      dialog.nxGuideOpener = opener;
      dialog.nxGuideOpenerId = opener.id;
      if (!dialog.open) dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-nx-size-guide-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    if (event.target.matches('dialog[data-nx-size-guide-dialog]')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    const dialog = event.target;
    if (!dialog.matches?.('[data-nx-size-guide-dialog]')) return;
    const opener = dialog.nxGuideOpener?.isConnected ? dialog.nxGuideOpener : document.getElementById(dialog.nxGuideOpenerId);
    opener?.focus({preventScroll:true});
  }, true);
}
  } catch(e) { console.error(e); }
})();

})();
